export const checkIsEmptyObject = (obj: {}) => Object.keys(obj).length === 0;
